const getShortPlanLabel = (plan) => {
    if (!plan) return null;
    const name = plan.name || plan.previous_plan?.name;
    if (!name || name === 'None') return null;
    return name.toUpperCase();
};

export default function getSubscriptionLabel(plan) {
    return getShortPlanLabel(plan);
}

export const getMembershipAccentColor = (membershipStatus) => {
    switch (membershipStatus) {
        case 'paid':
            return '#95F205';
        case 'free_trial':
            return '#98C9F6';
        case 'expired':
        case 'lapsed':
            return '#f87171';
        default:
            return 'rgba(255,255,255,0.85)';
    }
};
